<template>
  <div class="switch-status">
    <span> {{ title }} </span>
    <div class="switch-group">
      <div v-for="seriesIndex in seriesIndexList" :key="seriesIndex" class="switch"
        :class="{ 'switch-open': sta(seriesList[seriesIndex]), 'small-switch': smallBtn }"
        :style="specialColor(seriesList[seriesIndex])">
        <div :class="{ 'small-btn': smallBtn }" class="switch-btn">{{ switchText(seriesList[seriesIndex]) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "switch-status-multi",
  props: {
    title: {
      type: String,
      required: true,
    },
    series: {
      type: [Object, Array],
      required: false,
    },
    smallBtn: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    seriesList() {
      if (this.series instanceof Array) {
        return this.series;
      } else {
        return [this.series];
      }
    },
    seriesIndexList() {
      let result = [];
      if (!this.seriesList) {
        return result;
      }

      for (let i = 0; i < this.seriesList.length; i++) {
        result.push(i);
      }
      return result;
    },
  },
  methods: {
    sta(seriesItem) {
      return seriesItem && !!seriesItem.data;
    },
    specialColor(seriesItem) {
      if (!seriesItem) return {};
      if (!seriesItem.isError) return "";
      if (seriesItem.isError === "Error" || (seriesItem.isZh && seriesItem.data === 1)) {
        if (this.title.indexOf("报警") >= 0 || seriesItem.isAlarm) {
          //报警
          return { backgroundColor: "#ff6666" };
        } else {
          //故障/默认
          return { backgroundColor: "#f00" };
        }
      } else if (seriesItem.isError === "Warning") {
        if (seriesItem.isNa) {
          // isNa===true 该设备当前不使用或现场无此设备
          return "";
        } else {
          return { backgroundColor: "#f7f910" };
        }
      }
    },
    switchText(seriesItem) {
      if (!seriesItem) {
        return "";
      }
      if (this.smallBtn) {
        return "";
      }

      //无数据报警文字
      const flag = seriesItem.data;
      if (seriesItem.isError === "Warning") {
        if (seriesItem.isNa) {
          // isNa===true 该设备当前不使用或现场无此设备
          return "NA";
        } else {
          // isError===Warning 直接 N/A
          return "N/A";
        }
      }

      //指定文字开关
      if (seriesItem.textOn && flag === 1) {
        return seriesItem.textOn;
      }
      if (seriesItem.textOff && flag === 0) {
        return seriesItem.textOff;
      }

      if (seriesItem.isZh) {
        // isZh===true 报警/故障/过载(默认)
        if (this.title.indexOf("报警") >= 0 || seriesItem.isAlarm) {
          if (flag === 0) {
            return "否";
          } else {
            return "报警";
          }
        } else if (this.title.indexOf("故障") >= 0 || seriesItem.isMalfunction) {
          if (flag === 0) {
            return "否";
          } else {
            return "故障";
          }
        } else if (this.title.indexOf("超温") >= 0) {
          if (flag === 0) {
            return "否";
          } else {
            return "超温";
          }
        } else if (this.title.indexOf("保护") >= 0) {
          if (flag === 0) {
            return "否";
          } else {
            return "保护";
          }
        } else if (this.title.indexOf("过载") >= 0) {
          if (flag === 0) {
            return "否";
          } else {
            return "过载";
          }
        }
        else {
          if (flag === 0) {
            return "正常";
          } else {
            return "过载";
          }
        }
      } else {
        // ON/OFF 运行开关
        if (flag) {
          return "运行";
        }
        return "停机";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-status {
  height: 42px;
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 0 10px !important;
  box-sizing: border-box;
  width: 100%;
  align-items: center;

  .switch-group {
    display: flex;

    .switch {
      width: 50px;
      height: 30px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      border-radius: 30px;
      display: flex;
      margin-left: 10px;

      &.switch-open {
        background-color: #5c8cd3;
        justify-content: flex-end;
        white-space: nowrap;
      }

      &-btn {
        width: 30px;
        height: 30px;
        font-size: 12px;
        user-select: none;
        line-height: 30px;
        text-align: center;
        border-radius: 50%;
        background-color: #fff;
        z-index: 20;
        transition: all 0.5s;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      }
    }

    .small-switch {
      width: 40px;
      height: 20px;
    }

    .small-btn {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
